"use client"

import { useSyncExternalStore } from "react"

import { screenCanPrepare, screenIsAwaitingHost, screenIsPainted, screenIsProbing, screenIsVisible, subscribeToScreenVisibility } from "@/platform/app-mode/screen-visibility"

const visibleOnTheServer = (): boolean => true

export const useScreenVisible = (): boolean => useSyncExternalStore(subscribeToScreenVisibility, screenIsVisible, visibleOnTheServer)

export const useScreenPainted = (): boolean => useSyncExternalStore(subscribeToScreenVisibility, screenIsPainted, visibleOnTheServer)

export const useScreenPreparation = (): boolean => useSyncExternalStore(subscribeToScreenVisibility, screenCanPrepare, visibleOnTheServer)

const notAwaitingOnTheServer = (): boolean => false

export const useScreenAwaitingHost = (): boolean => useSyncExternalStore(subscribeToScreenVisibility, screenIsAwaitingHost, notAwaitingOnTheServer)

const notProbingOnTheServer = (): boolean => false

export const useScreenProbing = (): boolean => useSyncExternalStore(subscribeToScreenVisibility, screenIsProbing, notProbingOnTheServer)
